import React from 'react';
import styled from 'styled-components';
import { DeviceType, ExposureLevel } from '../../../shared/enum/EnumRepository';
import { useDeviceStore } from '../../../shared/store/deviceStore';
import { MemberFilterData } from '../../../shared/dto/EntityRepository';
import { UniversalCheckbox } from '../../../shared/component/UniversalCheckbox';

const EXPOSURE_FILTER_ORDER: ExposureLevel[] = [
  ExposureLevel.PUBLIC,
  ExposureLevel.SEARCHABLE,
  ExposureLevel.PRIVATE,
];

interface FilterStationMemberIsPublicProps {
  currentFilter: MemberFilterData;
  setCurrentFilter: (filter: MemberFilterData) => void;
}

const FilterStationMemberIsPublic: React.FC<FilterStationMemberIsPublicProps> = ({ currentFilter, setCurrentFilter }) => {
  const { deviceType } = useDeviceStore();
  const isExposureAll = EXPOSURE_FILTER_ORDER.every((level) => currentFilter.isPublic[level]);

  const handleExposureChange = (level: ExposureLevel) => {
    setCurrentFilter({
      ...currentFilter,
      isPublic: { ...currentFilter.isPublic, [level]: !currentFilter.isPublic[level] },
    });
  };

  const handleExposureChangeAll = () => {
    const next = !isExposureAll;
    setCurrentFilter({
      ...currentFilter,
      isPublic: {
        [ExposureLevel.PUBLIC]: next,
        [ExposureLevel.SEARCHABLE]: next,
        [ExposureLevel.PRIVATE]: next,
      },
    });
  };

  return (
    <MemberIsPublicFilterComp>
      <MemberIsPublicSubTitle $isMobile={deviceType === DeviceType.MOBILE}>Exposure</MemberIsPublicSubTitle>
      <MemberIsPublicFilterList $isMobile={deviceType === DeviceType.MOBILE}>
        {EXPOSURE_FILTER_ORDER.map((level) => (
          <CheckboxComp key={level}>
            <UniversalCheckbox
              checked={currentFilter.isPublic[level]}
              onChange={() => handleExposureChange(level)}
            />
            {level}
          </CheckboxComp>
        ))}
        <CheckboxComp>
          <UniversalCheckbox
            checked={isExposureAll}
            onChange={handleExposureChangeAll}
          />
          Select ALL
        </CheckboxComp>
      </MemberIsPublicFilterList>
    </MemberIsPublicFilterComp>
  );
};


export default FilterStationMemberIsPublic;


const MemberIsPublicSubTitle = styled.div<{ $isMobile: boolean }>`
  margin-bottom: ${({ $isMobile }) => $isMobile ? '2vh' : '1.2vh'};
  ${({ theme, $isMobile }) => $isMobile ? theme.typography.Body_02_1 : theme.typography.Body_03_1};
`

const MemberIsPublicFilterComp = styled.div`
  display: flex;
  flex-direction: column;
`
const MemberIsPublicFilterList = styled.div<{ $isMobile: boolean }>`
  display: ${({ $isMobile }) => $isMobile ? 'grid' : 'flex'};
  flex-direction: column;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ $isMobile }) => $isMobile ? '1vh' : '4px'};
`

const CheckboxComp = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 4px;
  user-select: none;
  ${({ theme }) => theme.typography.Body_04};
  color: ${({ theme }) => theme.colors.color_Gray_03};
`;